import script from "./NetworkSwitchWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./NetworkSwitchWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./NetworkSwitchWrapper.vue?vue&type=style&index=0&id=2c578105&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c578105"]])

export default __exports__